<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import SubmissionWizard from './Wizard'
  import * as restfulService from '../../../../services/restfulService'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'
  import helperMixin from '../../../../../mixins/helper'
  import swal from 'sweetalert2'
  import {clone} from 'lodash'

  const defaultState = {
    id: null,
    activeStep: 'home',
    main_event: {
      id: '',
      title: '',
      website: '',
      max_submissions_per_author: ''
    },
    event: {
      id: '',
      title: '',
      website: ''
    },
    event_title: '',
    event_paper_type_id: '',
    event_paper_type: {},
    paper_type: {
      id: '',
      name: ''
    },
    terms: false,
    fields: [],
    authors: [],
    knowledge_area_1_id: '',
    knowledge_area_2_id: '',
    knowledge_area_3_id: '',
    knowledge_area_4_id: ''
  }

  export default {
    components: {SubmissionWizard, ValidationMessage},
    mixins: [helperMixin],
    props: ['submission'],
    data () {
      return {
        isSubmitted: false,
        submissionDisabled: false,
        data: clone(defaultState),
        website: '',
        dependencies: {
          events: [],
          paper_types: []
        }
      }
    },
    computed: {
      event: function () {
        return this.dependencies.events.filter((item) => {
          return item.id === this.data.event_id
        })[0]
      }
    },
    validations: {
      data: {
        event_id: {required},
        event_paper_type_id: {required},
        terms: {required}
      }
    },
    mounted () {
      this.data = clone(defaultState)
      restfulService.post('event', 'submissions-opened', null, {})
        .then(response => {
          this.data.main_event.id = response.main_event.id
          this.data.main_event.title = response.main_event.title
          this.data.main_event.website = response.main_event.website
          this.data.main_event.max_submissions_per_author = response.main_event.max_submissions_per_author

          this.dependencies.events = [...this.dependencies.events, ...response.events]
          this.data.id = null

          if (this.submission) {
            this.data = {...this.data, ...this.submission}
            this.data.activeStep = 'home'
          }

          if (this.data.event_paper_type_id) {
            this.onSelectEvent()
          }

          bus.$emit('hide-loader')
        })
        .catch(e => {
          bus.$emit('hide-loader')
          console.log(e)
        })
    },
    methods: {
      onSelectEvent () {
        bus.$emit('show-loader')
        this.dependencies.paper_types.splice(0)
        if (this.data.event_id) {
          restfulService.get('event', null, this.data.event_id, ['id'], ['paper_types_with_submissions_opened.paper_type'])
            .then(response => {
              const eventSelected = this.dependencies.events.find(item => item.id === this.data.event_id)
              this.website = eventSelected.website || this.data.main_event.website
              this.dependencies.paper_types = [...this.dependencies.paper_types, ...response.paper_types_with_submissions_opened]
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        } else {
          bus.$emit('hide-loader')
          this.data.event_paper_type_id = ''
        }
      },
      onSelectPaperType () {
        bus.$emit('show-loader')
        if (this.data.event_paper_type_id) {
          const eventSelected = this.dependencies.events.find(item => item.id === this.data.event_id)
          const eventPaperType = this.dependencies.paper_types.find(item => item.id === this.data.event_paper_type_id)
          if (eventPaperType && eventPaperType.paper_type.key !== 'minicursos' && eventSelected.person_papers >= this.data.main_event.max_submissions_per_author) {
            this.submissionDisabled = true
            bus.$emit('hide-loader')
            swal({
              title: 'Atenção',
              html: 'Você não pode mais submeter trabalhos nesse evento, o limite máximo é de: ' + this.data.main_event.max_submissions_per_author + ' submissões.',
              type: 'warning'
            })
            this.data.event_paper_type_id = ''
          } else {
            this.data.event.id = eventSelected.id
            this.data.event.title = eventSelected.title
            this.data.paper_type.id = eventPaperType.paper_type.id
            this.data.paper_type.name = eventPaperType.paper_type.name
            restfulService.get('event_paper_type', null, this.data.event_paper_type_id, null, ['paper_type', 'fields.field'])
              .then((response) => {
                this.data.event_paper_type = response
                response.fields.forEach((item) => {
                  if (item.field.type === 'file') {
                    item.value = {
                      name: '',
                      base64: '',
                      size: 0
                    }
                    item.isInvalid = true
                  } else {
                    if (item.field.show_helper) {
                      item.field.description = this.nl2br(item.field.description)
                    }
                    item.value = ''
                  }
                })
                this.data.fields = response.fields
                console.log(this.data.fields)
                this.data.event_paper_type = response
                this.submissionDisabled = false
                bus.$emit('hide-loader')
              })
              .catch(e => {
                bus.$emit('hide-loader')
                console.log(e)
              })
          }
        } else {
          bus.$emit('hide-loader')
        }
      },
      onNextStep (nextRoute) {
        this.isSubmitted = true
        this.data.id = this.$route.params.registrationId
        let params = {submission: this.data}
        this.$router.push({name: nextRoute, params})
      }
    }
  }
</script>

<template>
    <div>
        <submission-wizard :active-step="data.activeStep"/>
        <div class="forms form-registration">
            <el-form ref="submission"
                     :model="data"
                     label-position="top">
                <h3 class="title-separator">Dados do Evento</h3>
                <el-form-item label="Evento"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.data.event_id.$error }">
                    <el-select v-model="data.event_id"
                               clearable
                               filterable
                               placeholder="Selecione o evento"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @change="onSelectEvent"
                               @input="$v.data.event_id.$touch()">
                        <el-option
                                v-for="item in dependencies.events"
                                :key="item.id + '_event'"
                                :label="item.title"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.data.event_id.$error"/>
                </el-form-item>
                <el-form-item label="Tipo de Trabalho"
                              class="is-required">
                    <el-select v-model="data.event_paper_type_id"
                               clearable
                               filterable
                               placeholder="Selecione o tipo de trabalho"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @change="onSelectPaperType">
                        <el-option
                                v-for="paper_type in dependencies.paper_types"
                                :key="paper_type.id + '_paper'"
                                :label="paper_type.paper_type.name"
                                :value="paper_type.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="data.main_event.id !== '' && website && this.data.event_id">
                    <h3 class="title-separator">Informações Legais</h3>
                    <el-form-item>
                        <div>
                            <strong>
                                Link do Evento/Regulamento:
                                <a :href="website" class="website-event" target="_blank">Acesse Aqui</a>
                            </strong>
                        </div>
                        <div>
                            <el-checkbox v-model="data.terms">
                                Confirmo que li e estou de acordo com o regulamento do evento
                            </el-checkbox>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item class="buttons-save">
                    <el-button type="primary"
                               size="large"
                               @click="onNextStep('submission.contents')"
                               :disabled="isSubmitted || $v.data.$invalid || submissionDisabled">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<style lang="scss">
    .website-event {
        color: #00a65a;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
</style>
